import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';

type $tsMigrateAny = any;

const baseHubSpotUrl = getFullUrl('api');

export const getSignedSrc = (fileManagerId: $tsMigrateAny) => {
  const portalId = PortalIdParser.get();
  return `${baseHubSpotUrl}/filemanager/api/v2/files/${fileManagerId}/signed-url-redirect?portalId=${portalId}`;
};

export const isPrivateFile = (fileObject: $tsMigrateAny) => {
  return fileObject.meta && fileObject.meta.allows_anonymous_access === false;
};
